import { render, staticRenderFns } from "./AddSuppression.vue?vue&type=template&id=3f75215c&scoped=true&"
import script from "./AddSuppression.vue?vue&type=script&lang=js&"
export * from "./AddSuppression.vue?vue&type=script&lang=js&"
import style0 from "./AddSuppression.vue?vue&type=style&index=0&id=3f75215c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f75215c",
  null
  
)

component.options.__file = "AddSuppression.vue"
export default component.exports